module.exports = __webpack_public_path__ + "media/seleect_reservation.9c8bcd7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/cloud/server/seleect_reservation.png
// module id = 741
// module chunks = 2